<style lang="less" scoped>
  @import '../index.less';
</style>

<template>
  <el-card>
    <div slot="header">
      <div class="order-info">
        <span class="order-orderSn">订单号：{{order.orderSn}}</span>
        <span class="order-date">下单时间：{{order.createdAt}}</span>
        <el-button type="text">
          <router-link :to="{ name: 'member-order-detail', params:{ id : order.id}}">
            查看订单
          </router-link>
        </el-button>
      </div>
      <div class="order-status">
        订单状态：{{getOrderStatus(order)}}
      </div>
    </div>
    <div class="member-order-list">
      <div class="order-list">
        <el-table class="table"
                  :data="order.orderProducts"
                  :show-header="false"
        >
          <el-table-column>
            <template slot-scope="scope">
              <div class="order-product-item">
                <div class="order-product-image">
                  <img :src="scope.row.image" alt="" class="member-order-image">
                </div>
                <div class="order-product-info order-product-name-info">
                  <div class="order-product-name">{{scope.row.productName}}</div>
                  <div class="order-product-mark">{{$enums.productMark.label(scope.row.mark)}}</div>
                </div>
                <div class="order-product-info order-product-price text-center">
                  ¥ {{ scope.row.salePrice }}
                </div>
                <div class="order-product-info order-product-number text-center">
                  {{ scope.row.number }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="order-price">
        <div>¥ {{order.orderAmount}}</div>
        <div class="text-center" :class="order.shippingStatus != 121 && order.orderStatus != 104 && order.orderStatus != 103
          ? 'red' : ''">{{getOrderStatus(order)}}</div>
      </div>
      <div class="order-payment">
        <el-button type="primary" :disabled="disable" @click="payOrder(order)"  v-if="showOrderPayment(order)">
          付款 <span>{{cancelTimeDesc}}</span>
        </el-button>
        <br/>
        <el-button type="text" @click="cancelOrder(order)"  v-if="showOrderPayment(order)">
          取消订单
        </el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
  import {payOrder, getOrderStatus} from "@/helpers/index";

  export default {
  name: 'OrderListItem',
  components: {
  },
  data(){
    return {
      cancelTime:0,
      cancelTimeDesc:'',
      disable:false
    }
  },
  props: {
    order: {
      required: true
    },
  },
  mounted() {
    this.handleOrderCancelTime()
  },
  updated() {

  },
  methods: {

    payOrder(order) {
      payOrder(this.$router, order)
    },

    /**
     * 处理订单自动关闭时间
     */
    handleOrderCancelTime() {
      let order = this.order
      let orderCancelTime = parseInt(this.order.activity.cancelTime) * 60 * 1000
      if(orderCancelTime == 0 || order.orderStatus != this.$enums.orderStatus.UNSETTLED){
        this.cancelTimeDesc = '';
        return;
      }
      setInterval(this.getOrderCancelTime,1000)

    },

    /**
     * 订单自动关闭时间
     */
    getOrderCancelTime(){
      let order = this.order
      let orderCancelTime = parseInt(this.order.activity.cancelTime) * 60 * 1000
      if(this.cancelTime != 0) {
        orderCancelTime = this.cancelTime--;
      }else{
        let currentTime =  new Date().getTime();
        let orderCreateTime = new Date(order.createdAt).getTime()
        orderCancelTime = parseInt(orderCancelTime)-(currentTime-orderCreateTime)

        if(orderCancelTime <= 0) {
          this.cancelTimeDesc = ''
          this.cancelTime = 0;
          this.disable = true;
          return
        }
        orderCancelTime = orderCancelTime/1000
        this.cancelTime = parseInt(orderCancelTime)
      }

      let minutes = parseInt(orderCancelTime / 60)
      let seconds = parseInt(orderCancelTime % 60)

      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds

      this.cancelTimeDesc = minutes + ":" + seconds;
    },

    /**
     * 获取订单状态
     */
    getOrderStatus(order) {
      return getOrderStatus(this.$enums, order)
    },

    /**
     * 是否显示支付链接
     */
    showOrderPayment(order) {
      if(order.orderStatus == this.$enums.orderStatus.CANCELLED || order.orderStatus == this.$enums.orderStatus.COMPLETED || order.payStatus == this.$enums.payStatus.PAID) {
        return false;
      }else {
        return true;
      }
    },

    /**
     * 取消订单
     * @param order 订单数据
     * @param isConfirm 是否显示确认框
     * @returns {Promise<void>}
     */
    async cancelOrder(order, isConfirm) {
      if(!isConfirm) {
        await this.$confirm('是否确认取消订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
      }

      await this.$store.dispatch('order/cancel',{ id:order.id });
      this.$emit('cancelOrder')
    },

  },
}
</script>


